import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { AgentDeskParams } from '../types/params.types'
import EntityFieldListing from '../components/listing-table/EntityFieldListing'

const EntitiesHomepage = ({ isSelected = false }) => {
  const { entityId } = useParams<AgentDeskParams>()
  const [selectedTab, setSelectedTab] = useState('')

  useEffect(() => {
    if (isSelected && entityId) {
      setSelectedTab(entityId)
    }
  }, [entityId, isSelected])

  return (
    <div className="h-full">
      <EntityFieldListing selectedTab={selectedTab} isSelected={isSelected} />
    </div>
  )
}
export default EntitiesHomepage
